import type React from 'react'
import { useContext } from 'react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button'

import { useSalesEditor } from '../hooks/use-sales-editor'
import { TableCustomizerContext } from '../state/table-customizer'

export const AddTableRowButton = () => {
  const { isEditing, activeTemplate } = useSalesEditor()
  const tableCustomizerContext = useContext(TableCustomizerContext)

  if (!isEditing || !activeTemplate || !tableCustomizerContext) {
    return null
  }

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation()
    tableCustomizerContext.onAddNewRow()
  }

  return (
    <Button
      size="icon"
      className="absolute -right-[50px] top-1/2 h-6 w-6 -translate-y-1/2 rounded-full"
      onClick={handleClick}
    >
      <PlusIcon />
    </Button>
  )
}
